import PropTypes from 'prop-types';
import createAvatar from '../../../utils/createAvatar';

import Avatar from './Avatar';

MyAvatar.propTypes = {
  title: PropTypes.string,
  photoUrl: PropTypes.string,
};

export default function MyAvatar({ title, photoUrl, ...other }) {
  return (
    <Avatar src={photoUrl} alt={title} color={photoUrl ? 'default' : createAvatar(title).color} {...other}>
      {createAvatar(title).name}
    </Avatar>
  );
}
